const BRAND_TV_DOMAIN = import.meta.env.VITE_BRAND_TV_DOMAIN;
const WEBINAR_PLUS_DOMAIN = import.meta.env.VITE_WEBINAR_PLUS_DOMAIN;

export const getThemeForCurrentLocation = () => {
  if (window.location.hostname.endsWith(BRAND_TV_DOMAIN)) {
    return 'brandtv';
  }
  if (window.location.hostname.endsWith(WEBINAR_PLUS_DOMAIN)) {
    return 'webinarplus';
  }
};
